"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYONEER_AVAILABLE_COUNTRIES = void 0;
exports.PAYONEER_AVAILABLE_COUNTRIES = {
    ARG: 'Argentina',
    BOL: 'Bolivia',
    BRA: 'Brazil',
    CHL: 'Chile',
    COL: 'Colombia',
    CRI: 'Costa Rica',
    ECU: 'Ecuador',
    GTM: 'Guatemala',
    MEX: 'Mexico',
    PER: 'Peru',
    SLV: 'El Salvador',
    URY: 'Uruguay',
    VEN: 'Venezuela',
};
